var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnRanking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2219"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2220"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 904",
    d: "M113.01 144.937v4.126a1 1 0 0 1-1.123 1.057q-2.2.006-4.4 0a1.029 1.029 0 0 1-1.153-1.068q-.005-4.06 0-8.121a1.971 1.971 0 0 1 2.143-1.988h2.467a1.927 1.927 0 0 1 2.063 1.912v4.082",
    transform: "translate(-87.689 -118.123)",
    style: {
      fill: "#1fb04b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 905",
    d: "M5.7 206.687v2.862a1.052 1.052 0 0 1-1.147 1.151q-1.7.007-3.4 0A1.067 1.067 0 0 1 0 209.529v-4.723a2.048 2.048 0 0 1 2.13-2.127q1.2-.006 2.4 0a1.058 1.058 0 0 1 1.17 1.17v2.838",
    transform: "translate(12 -178.699)",
    style: {
      fill: "#1fb04b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 906",
    d: "M106.968 5.694a6.968 6.968 0 0 1 .208-.975.507.507 0 0 0-.158-.562c-.192-.169-.365-.359-.542-.544a1.9 1.9 0 0 1-.221-.269.848.848 0 0 1 .469-1.356 5.419 5.419 0 0 1 .976-.188.5.5 0 0 0 .435-.322c.124-.284.274-.557.413-.834a.932.932 0 0 1 1.774-.014c.152.3.308.592.446.9a.438.438 0 0 0 .372.269c.291.043.583.085.87.148a.884.884 0 0 1 .517 1.546c-.221.259-.473.492-.717.73a.384.384 0 0 0-.123.415c.084.314.149.634.207.954a.893.893 0 0 1-.29.927.878.878 0 0 1-.949.055 7.868 7.868 0 0 1-.968-.555.4.4 0 0 0-.474 0c-.235.151-.478.289-.721.426a2.291 2.291 0 0 1-.356.17c-.656.233-1.178-.146-1.169-.916",
    transform: "translate(-87.448 12)",
    style: {
      fill: "#1fb04b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 907",
    d: "M231.815 255.269h-1.675a1.062 1.062 0 0 1-1.178-1.183v-2.745a1 1 0 0 1 .973-1.092 20.657 20.657 0 0 1 2.9.017 1.979 1.979 0 0 1 1.815 2.013c.015.628.01 1.256 0 1.884a1.058 1.058 0 0 1-1.12 1.106h-1.722",
    transform: "translate(-202.665 -223.272)",
    style: {
      fill: "#1fb04b"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 5217",
    style: {
      fill: "none"
    },
    d: "M0 0h44v44H0z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnRanking);
export default __webpack_public_path__ + "static/media/icn_ranking.ccea873b1578c88062384c7076cfe4fc.svg";
export { ForwardRef as ReactComponent };